import React, { useState } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  Icon,
  OutlinedInput,
  Box,
  TextField,
  Divider,
  FormHelperText
} from '@material-ui/core';
import { createTheme, ThemeProvider, Theme, withStyles, makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import BasicTheme from 'themes'; 

interface Options {
  label:string;
  value: string | number;
}
interface LbSelectInputProps extends React.ComponentPropsWithRef<typeof Select> {
  configName?:string;
  themeName?:string;
  onSelectChange?(event:any,child:any):void;
  onInputChange?(event:any):void;
  options:Options[];
  values?: {
    select?:string | number | unknown;
    input?:string | number | unknown;
  },
  helperText?:React.ReactNode;
  previewTheme?: Theme
}

const TextFiledCustom = withStyles((theme:Theme) => {
  return {
    root: {
      backgroundColor: theme.palette.background.default
    }
  }
})(TextField);

const useStyles = makeStyles((theme) => {
  return {
    outlinedBox: {
      border: `1px solid ${theme.palette.border.main}`,
      borderRadius: 8,
      overflow: 'hidden'
    },
    noMerge: {
      margin: 0
    },
    flex1: {
      flex: 1
    }
  }
})

const LbSelectInput = (props: LbSelectInputProps) => {
  const {configName, themeName, options, onSelectChange, onInputChange, name, error, helperText, previewTheme } = props;
  const componentConfig = require(`./${configName || 'config'}.json`);
  const componentTheme = require(`./${themeName || 'theme'}.json`);
  const classes = useStyles();
  const [selectValue, setSelectValue] = useState<string | number | unknown>(props.values?.select || '');
  const [inputValue, setInputValue] = useState<string | number | unknown>(props.values?.input || '');
  const handleSelectCahange = (event: React.ChangeEvent<{
    name?: string | undefined;
    value: string | number | unknown;
}>, child: React.ReactNode) => {
  setSelectValue(event.target.value)
    if(typeof onSelectChange === 'function') {
      onSelectChange(event, child)
    }
  }

  const handleInputCahange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    if(typeof onInputChange === 'function') {
      onInputChange(event)
    }
  }

  const defaultTheme = createTheme(_.defaultsDeep(componentTheme,BasicTheme))
  const theme:any = createTheme(_.defaultsDeep({
    overrides: {
      MuiOutlinedInput: {
        root: {
          borderRadius: 0
        },
        notchedOutline: {
          border: 'none'
        }
      }
    }
  },previewTheme || defaultTheme));

  return (
    <ThemeProvider<Theme> theme={theme}>
      <Box display="flex" className={classes.outlinedBox}>
        <FormControl variant="outlined" margin="dense" className={classes.noMerge}>
          <Box display="flex">
            <Select
              onChange={handleSelectCahange}
              value={selectValue}
              IconComponent={({className}) => {
                const isOpen:boolean = !!className.match('Open');
                return !!options.length ? null : <Box position="absolute" right={7} color={theme.overrides?.MuiSelect?.iconOutlined['color'] || '#fff'}><Icon fontSize="inherit">{isOpen ? 'expand_less' : 'expand_more'}</Icon></Box>
              }}
            >
              {
                options.map((item:Options, index:number) => {
                  return (
                    <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                  )
                })
              }
            </Select>
            <Divider flexItem orientation="vertical" />
          </Box>
        </FormControl>
        <FormControl className={classes.flex1} >
          <TextFiledCustom name={name} className={classes.noMerge} variant="outlined" margin="dense"  value={inputValue} onChange={handleInputCahange} 
          error={error}
          />
        </FormControl>
      </Box>
      {
      error && <FormHelperText error={error}>{helperText}</FormHelperText>
      }
    </ThemeProvider>
  )
}

export default LbSelectInput;